export const REPORT_SETTINGS_PREFIX = 'reports';
export const PRESET_SETTINGS_PREFIX = 'presets';
